const manifestationTemplate14133 = (biddingNumber?: string) => `
  <div class="manifestation-body">
    <p class="manifestation-title">Sugestão de Manifestação 14.133</p>
    <p>Ao(À)</p>
    <p><span class="manifestation-highlight">[Inserir órgão destinatário]</span></p>
    <p><span class="manifestation-highlight">[Inserir autoridade competente]</span></p>
    <p>
      Ref.:
      <span class="manifestation-highlight">
        [${biddingNumber || 'Inserir número do edital de licitação/processo licitatório'}]
      </span>
    </p>
    <p>
      <span class="manifestation-highlight">[Inserir razão social da empresa]</span>, inscrita no
      CNPJ sob nº <span class="manifestation-highlight">[inserir número]</span>, com sede em
      <span class="manifestation-highlight">[inserir cidade/UF]</span>, situada na
      <span class="manifestation-highlight">[inserir nome da rua]</span>, nº
      <span class="manifestation-highlight">[inserir número]</span>, CEP
      <span class="manifestation-highlight">[inserir CEP]</span>, neste ato representada por seu
      representante legal ao final subscrito, vem, respeitosamente, à presença de Vossa Senhoria,
      com fundamento no art. 5º, inciso XXXIV, alínea “a”, da Constituição Federal, apresentar o
      presente <strong>REQUERIMENTO ADMINISTRATIVO</strong>, pelas razões de fato e de direito a
      seguir expostas.
    </p>
    <p>
      Como é de conhecimento desta Administração, a Requerente sagrou-se vencedora do Pregão
      Eletrônico nº <span class="manifestation-highlight">[inserir nº]</span>, cujo objeto
      consiste na contratação de
      <span class="manifestation-highlight">
        [descrever o objeto, conforme especificações do Edital e seus anexos]
      </span>.
    </p>
    <p>
      Ocorre que, ao receber o Contrato Administrativo nº
      <span class="manifestation-highlight">[inserir nº]</span> para assinatura, a Requerente
      verificou a existência de divergências em relação à minuta de contrato constante do edital,
      documento este que integra o instrumento convocatório e estabelece previamente as condições
      contratuais que regerão a futura contratação.
    </p>
    <p>
      Nesse contexto, cumpre destacar que o contrato administrativo a ser celebrado deve guardar
      estrita correspondência com a minuta que integrou o edital da licitação, não sendo
      admissíveis alterações unilaterais que modifiquem as condições previamente estabelecidas no
      instrumento convocatório.
    </p>
    <p>
      Com efeito, qualquer divergência entre o contrato apresentado para assinatura e a minuta
      constante do edital viola o princípio da vinculação ao instrumento convocatório, expressamente
      previsto no art. 5º da Lei nº 14.133/2021, in verbis:
    </p>
    <blockquote>
      “Art. 5º Na aplicação desta Lei, serão observados os princípios da legalidade, da
      impessoalidade, da moralidade, da publicidade, da eficiência, do interesse público, da
      probidade administrativa, da igualdade, do planejamento, da transparência, da eficácia, da
      segregação de funções, da motivação, da vinculação ao edital, do julgamento objetivo, da
      segurança jurídica, da razoabilidade, da competitividade, da proporcionalidade, da celeridade,
      da economicidade e do desenvolvimento nacional sustentável, assim como as disposições do
      Decreto-Lei nº 4.657, de 4 de setembro de 1942 (Lei de Introdução às Normas do Direito
      Brasileiro).”
    </blockquote>
    <p>
      O referido princípio impõe à Administração Pública e aos licitantes o cumprimento estrito das
      regras estabelecidas no edital, sendo inadmissível o afastamento de qualquer exigência ou
      condição previamente fixada no instrumento convocatório.
    </p>
    <p>
      A doutrina de Joel de Menezes Niebuhr é categórica ao afirmar a necessidade de observância
      rigorosa das disposições editalícias:
    </p>
    <blockquote>
      “Diante dessa perspectiva, por princípio, uma vez publicado o edital, a Administração e os
      licitantes estão vinculados a ele, não podem se apartar ou se divorciar dos seus termos. A
      discricionariedade existente no momento da produção do edital se dissipa e dá lugar à
      vinculação. À Administração não é permitido fazer exigências não previstas no edital nem
      deixar de exigir aquilo que fora prescrito nele. Os licitantes, por sua vez, devem cumprir os
      termos estabelecidos no edital. Eis o princípio da vinculação ao edital.” (Licitação Pública
      e Contrato Administrativo (p. 94). Ed.:Fórum. 5ª Edição.)
    </blockquote>
    <p>
      No mesmo sentido, o Tribunal de Contas da União já se manifestou acerca da obrigatoriedade de
      observância das regras editalícias, conforme trecho do Acórdão 1934/2021 – Plenário do TCU:
    </p>
    <blockquote>
      "38. Edital é lei interna da licitação e 'vincula inteiramente a Administração e os
      proponentes' (Hely Lopes Meirelles).<br />
      38.1. Dito isso, pode se dizer, sob um certo ângulo, que o Edital é o fundamento de validade
      dos atos praticados no curso da licitação, na acepção de que a desconformidade entre o edital
      e os atos administrativos praticados no curso da licitação se resolve pela invalidade deste
      último.<br />
      38.2. A Administração Pública concede ao particular prazo para questionar ou impugnar o
      Edital, devendo este momento servir para alterar possíveis vícios no documento convocatório.
      Portanto, não nos parece condizente aceitar que o Edital seja modificado já na sua fase
      final, simplesmente porque violou os interesses particular de alguma licitante, é o que
      geralmente ocorre.<br />
      38.3. A partir disso é que o princípio da vinculação ao instrumento convocatório se aplica,
      obrigando a Administração Pública a cumprir com todos os itens, requisitos e cláusulas
      inerentes do Edital. Mesmo porque a licitante (empresa participante do certame) confere,
      atesta e declara que tomou conhecimento do instrumento convocatório, e que preenche todos os
      requisitos do Edital.<br />
      38.4. Por este motivo, é que entendemos que não deverá ocorrer em hipótese alguma o
      descumprimento do princípio da vinculação ao instrumento convocatório, tanto na via
      administrativa, quanto na via judicial.<br />
      38.5. Por todo o exposto, conclui-se que a Administração Pública, no curso do processo de
      licitação, não pode se afastar das regras por ela mesma estabelecidas no instrumento
      convocatório, pois, para garantir segurança e estabilidade às relações jurídicas decorrentes
      do certame licitatório, bem como para se assegurar o tratamento isonômico entre os
      licitantes, é necessário observar estritamente as disposições constantes do edital.” (Acórdão
      1934/2021 - Plenário. Relator: Raimundo Carreiro)
    </blockquote>
    <p>
      Dessa forma, considerando que a minuta contratual constante do edital estabeleceu previamente
      as condições da futura contratação, eventual divergência no contrato apresentado para
      assinatura deve ser devidamente corrigida, de modo a preservar a legalidade do procedimento e
      a observância do princípio da vinculação ao instrumento convocatório.
    </p>
    <p>Diante do exposto, requer-se:</p>
    <p>
      a) que seja revista a versão do Contrato Administrativo nº
      <span class="manifestation-highlight">[inserir nº]</span>, a fim de adequá-la integralmente à
      minuta de contrato constante do edital do Pregão Eletrônico nº
      <span class="manifestation-highlight">[inserir nº]</span>;
    </p>
    <p>
      b) que seja encaminhada à Requerente a versão do contrato em estrita conformidade com o
      edital, para fins de assinatura e regular formalização da contratação.
    </p>
    <p>Termos em que,<br />pede deferimento.</p>
    <p>
      <span class="manifestation-highlight">[Cidade/UF]</span>,
      <span class="manifestation-highlight">[data]</span>.
    </p>
    <p><span class="manifestation-highlight">[Inserir número do CNPJ]</span></p>
    <p><span class="manifestation-highlight">[Inserir Nome Completo do Representante Legal]</span></p>
    <p><span class="manifestation-highlight">[Inserir CPF do Representante Legal]</span></p>
  </div>
`;

const manifestationTemplate13303 = (biddingNumber?: string) => `
  <div class="manifestation-body">
    <p class="manifestation-title">Sugestão de Manifestação 13.303</p>
    <p>Ao(À)</p>
    <p><span class="manifestation-highlight">[Inserir órgão destinatário]</span></p>
    <p><span class="manifestation-highlight">[Inserir autoridade competente]</span></p>
    <p>
      Ref.:
      <span class="manifestation-highlight">
        [${biddingNumber || 'Inserir número do edital de licitação/processo licitatório'}]
      </span>
    </p>
    <p>
      <span class="manifestation-highlight">[Inserir razão social da empresa]</span>, inscrita no
      CNPJ sob nº <span class="manifestation-highlight">[inserir número]</span>, com sede em
      <span class="manifestation-highlight">[inserir cidade/UF]</span>, situada na
      <span class="manifestation-highlight">[inserir nome da rua]</span>, nº
      <span class="manifestation-highlight">[inserir número]</span>, CEP
      <span class="manifestation-highlight">[inserir CEP]</span>, neste ato representada por seu
      representante legal ao final subscrito, vem, respeitosamente, à presença de Vossa Senhoria,
      com fundamento no art. 5º, inciso XXXIV, alínea “a”, da Constituição Federal, apresentar o
      presente <strong>REQUERIMENTO ADMINISTRATIVO</strong>, pelas razões de fato e de direito a
      seguir expostas.
    </p>
    <p>
      Como é de conhecimento desta Administração, a Requerente sagrou-se vencedora do Pregão
      Eletrônico nº <span class="manifestation-highlight">[inserir nº]</span>, cujo objeto
      consiste na contratação de
      <span class="manifestation-highlight">
        [descrever o objeto, conforme especificações do Edital e seus anexos]
      </span>.
    </p>
    <p>
      Ocorre que, ao receber o Contrato Administrativo nº
      <span class="manifestation-highlight">[inserir nº]</span> para assinatura, a Requerente
      verificou a existência de divergências em relação à minuta de contrato constante do edital,
      documento este que integra o instrumento convocatório e estabelece previamente as condições
      contratuais que regerão a futura contratação.
    </p>
    <p>
      Nesse contexto, cumpre destacar que o contrato administrativo a ser celebrado deve guardar
      estrita correspondência com a minuta que integrou o edital da licitação, não sendo
      admissíveis alterações unilaterais que modifiquem as condições previamente estabelecidas no
      instrumento convocatório.
    </p>
    <p>
      Com efeito, qualquer divergência entre o contrato apresentado para assinatura e a minuta
      constante do edital viola o princípio da vinculação ao instrumento convocatório, expressamente
      previsto no art. 31 da Lei nº 13.303/2016, in verbis:
    </p>
    <blockquote>
      Art. 31. As licitações realizadas e os contratos celebrados por empresas públicas e
      sociedades de economia mista destinam-se a assegurar a seleção da proposta mais vantajosa,
      inclusive no que se refere ao ciclo de vida do objeto, e a evitar operações em que se
      caracterize sobrepreço ou superfaturamento, devendo observar os princípios da
      impessoalidade, da moralidade, da igualdade, da publicidade, da eficiência, da probidade
      administrativa, da economicidade, do desenvolvimento nacional sustentável, da vinculação ao
      instrumento convocatório, da obtenção de competitividade e do julgamento objetivo.
    </blockquote>
    <p>
      O referido princípio impõe à Administração Pública e aos licitantes o cumprimento estrito das
      regras estabelecidas no edital, sendo inadmissível o afastamento de qualquer exigência ou
      condição previamente fixada no instrumento convocatório.
    </p>
    <p>
      A doutrina de Joel de Menezes Niebuhr é categórica ao afirmar a necessidade de observância
      rigorosa das disposições editalícias:
    </p>
    <blockquote>
      “Diante dessa perspectiva, por princípio, uma vez publicado o edital, a Administração e os
      licitantes estão vinculados a ele, não podem se apartar ou se divorciar dos seus termos. A
      discricionariedade existente no momento da produção do edital se dissipa e dá lugar à
      vinculação. À Administração não é permitido fazer exigências não previstas no edital nem
      deixar de exigir aquilo que fora prescrito nele. Os licitantes, por sua vez, devem cumprir os
      termos estabelecidos no edital. Eis o princípio da vinculação ao edital.” (Licitação Pública
      e Contrato Administrativo (p. 94). Ed.:Fórum. 5ª Edição.)
    </blockquote>
    <p>
      No mesmo sentido, o Tribunal de Contas da União já se manifestou acerca da obrigatoriedade de
      observância das regras editalícias, conforme trecho do Acórdão 1934/2021 – Plenário do TCU:
    </p>
    <blockquote>
      "38. Edital é lei interna da licitação e 'vincula inteiramente a Administração e os
      proponentes' (Hely Lopes Meirelles).<br />
      38.1. Dito isso, pode se dizer, sob um certo ângulo, que o Edital é o fundamento de validade
      dos atos praticados no curso da licitação, na acepção de que a desconformidade entre o edital
      e os atos administrativos praticados no curso da licitação se resolve pela invalidade deste
      último.<br />
      38.2. A Administração Pública concede ao particular prazo para questionar ou impugnar o
      Edital, devendo este momento servir para alterar possíveis vícios no documento convocatório.
      Portanto, não nos parece condizente aceitar que o Edital seja modificado já na sua fase
      final, simplesmente porque violou os interesses particular de alguma licitante, é o que
      geralmente ocorre.<br />
      38.3. A partir disso é que o princípio da vinculação ao instrumento convocatório se aplica,
      obrigando a Administração Pública a cumprir com todos os itens, requisitos e cláusulas
      inerentes do Edital. Mesmo porque a licitante (empresa participante do certame) confere,
      atesta e declara que tomou conhecimento do instrumento convocatório, e que preenche todos os
      requisitos do Edital.<br />
      38.4. Por este motivo, é que entendemos que não deverá ocorrer em hipótese alguma o
      descumprimento do princípio da vinculação ao instrumento convocatório, tanto na via
      administrativa, quanto na via judicial.<br />
      38.5. Por todo o exposto, conclui-se que a Administração Pública, no curso do processo de
      licitação, não pode se afastar das regras por ela mesma estabelecidas no instrumento
      convocatório, pois, para garantir segurança e estabilidade às relações jurídicas decorrentes
      do certame licitatório, bem como para se assegurar o tratamento isonômico entre os
      licitantes, é necessário observar estritamente as disposições constantes do edital.” (Acórdão
      1934/2021 - Plenário. Relator: Raimundo Carreiro)
    </blockquote>
    <p>
      Dessa forma, considerando que a minuta contratual constante do edital estabeleceu previamente
      as condições da futura contratação, eventual divergência no contrato apresentado para
      assinatura deve ser devidamente corrigida, de modo a preservar a legalidade do procedimento e
      a observância do princípio da vinculação ao instrumento convocatório.
    </p>
    <p>Diante do exposto, requer-se:</p>
    <p>
      a) que seja revista a versão do Contrato Administrativo nº
      <span class="manifestation-highlight">[inserir nº]</span>, a fim de adequá-la integralmente à
      minuta de contrato constante do edital do Pregão Eletrônico nº
      <span class="manifestation-highlight">[inserir nº]</span>;
    </p>
    <p>
      b) que seja encaminhada à Requerente a versão do contrato em estrita conformidade com o
      edital, para fins de assinatura e regular formalização da contratação.
    </p>
    <p>Termos em que,<br />pede deferimento.</p>
    <p>
      <span class="manifestation-highlight">[Cidade/UF]</span>,
      <span class="manifestation-highlight">[data]</span>.
    </p>
    <p><span class="manifestation-highlight">[Inserir número do CNPJ]</span></p>
    <p><span class="manifestation-highlight">[Inserir Nome Completo do Representante Legal]</span></p>
    <p><span class="manifestation-highlight">[Inserir CPF do Representante Legal]</span></p>
  </div>
`;

export const getManifestationTemplate = (law?: string | number, biddingNumber?: string) =>
  Number(law) === 14133
    ? manifestationTemplate14133(biddingNumber)
    : manifestationTemplate13303(biddingNumber);
